/**
 * Maakt een veilige CSV-cel. Tekst die in Excel als formule zou worden gelezen
 * (beginnend met = + - @) krijgt een apostrof ervoor, zodat een notitie nooit code kan uitvoeren.
 */
export function csvCell(value: string | number | undefined): string {
  let text = value === undefined ? '' : String(value);
  if (typeof value === 'string' && /^[=+\-@\t\r]/.test(text)) text = "'" + text;
  return /[",;\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** CSV met puntkomma als scheidingsteken, zodat Excel in Nederland het direct in kolommen zet. */
export function toCsv(header: string[], rows: (string | number | undefined)[][]): string {
  return [header.join(';'), ...rows.map((r) => r.map(csvCell).join(';'))].join('\r\n') + '\r\n';
}

/** Laat de browser een bestand downloaden. Met BOM, zodat Excel UTF-8 (é, ë) goed leest. */
export function downloadCsv(filename: string, csv: string) {
  const url = URL.createObjectURL(new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
